import { type IconButtonProps } from "@clipboard-health/ui-components";
import { AbsoluteSmallButton } from "@src/appV2/redesign/components/AbsoluteSmallButton";

export function TopRightCloseButton(props: { onClick: () => void } & Partial<IconButtonProps>) {
  return <AbsoluteSmallButton iconType="close" position="right" label="Close" {...props} />;
}
